import {Map, View} from 'ol';
import OSM from 'ol/source/OSM';
import Vector from 'ol/source/Vector';
import BingMaps from 'ol/source/BingMaps';
import TileWMS from 'ol/source/TileWMS';

import GeoJSON from 'ol/format/GeoJSON';
import WFS from 'ol/format/WFS';
import Bbox from 'ol/format/filter/Bbox';

import {and, like, or} from 'ol/format/filter';

import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';

import {Group as LayerGroup, Tile as TileLayer} from 'ol/layer';
import * as olProj from 'ol/proj';
import { register } from "ol/proj/proj4";
import { get as getProjection, transformExtent } from "ol/proj";
import proj4 from "proj4";

import {defaults} from 'ol/control';
import MousePosition from 'ol/control/MousePosition';
import ZoomToExtent from 'ol/control/ZoomToExtent';

import {createStringXY} from 'ol/coordinate';
import {getCenter} from 'ol/extent';

import { Tab } from "bootstrap/js/dist/tab";
import VectorLayer from 'ol/layer/Vector';

var delay = (function(){
  var timer = 0;
  return function(callback, ms){
    clearTimeout (timer);
    timer = setTimeout(callback, ms);
  };
})();

//Define and reproject to EPSG:32635
proj4.defs(
  "EPSG:32635",
  "+proj=utm +zone=35 +ellps=WGS84 +datum=WGS84 +units=m +no_defs"
);
register(proj4);

const proj32635 = getProjection("EPSG:32635");
proj32635.setExtent([166021.44, 0.00, 534994.66, 9329005.18]);
var bounds = [256140.98, 4804337.74,
  277779.28, 4833620.33];

const layers = {};

let format = 'image/png';

layers["osm"] = new TileLayer({
  source: new OSM(),
  name: 'osm',
  visible: true
});

layers["osmsat"] = new TileLayer({
  preload: Infinity,
  source: new BingMaps({
    key: 'ApOScIyoy5snT55MKP2anLg08A9tPv_tEIATyUcpiTuiFQLvT16dxQA-39BvgZWE',
    imagerySet: 'AerialWithLabelsOnDemand',
  }),
  name: 'osmsat',
  visible: false
});

layers["Borduri"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:Borduri",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Бордюри',
  serverName: 'Borduri',
  visible: false
});
layers["Osi_tr"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:Osi_tr",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Осеви точки',
  serverName: 'Osi_tr',
  visible: false
});
layers["Imoti_i_PUPs_ot_regulacionni_karti_tr"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:Imoti_i_PUPs_ot_regulacionni_karti_tr",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Дворищна регулация',
  serverName: 'Imoti_i_PUPs_ot_regulacionni_karti_tr',
  visible: false
});
layers["Osova_liniya"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:Osova_liniya",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Осева линия',
  serverName: 'Osova_liniya',
  visible: false
});
layers["Dimensions"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:Dimensions",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Отстояние',
  serverName: 'Dimensions',
  visible: false
});
layers["Ulicna_regul"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:Ulicna_regul",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Улична регулация',
  serverName: 'Ulicna_regul',
  visible: false
});
layers["Regul_kvartali"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:Regul_kvartali",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Регулационен квартал',
  serverName: 'Regul_kvartali',
  visible: false
});
layers["PUPove"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:PUPove",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Урегулирани поземлени имоти',
  serverName: 'PUPove',
  visible: false
});

var layerGroupRegulacia = new LayerGroup({
  layers: [layers["PUPove"],layers["Regul_kvartali"],layers["Dimensions"],layers["Ulicna_regul"],layers["Osova_liniya"],layers["Imoti_i_PUPs_ot_regulacionni_karti_tr"],layers["Osi_tr"],layers["Borduri"]],
  name: 'Регулация'
});

layers["KIN"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:KIN",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Културно историческо наследство',
  serverName: 'KIN',
  visible: false
});
layers["AKB_Kneja"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:AKB_Kneja",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Охранителна зона на археологическa културна ценност с категория "национално значение"',
  serverName: 'AKB_Kneja',
  visible: false
});
layers["Naseleni_mesta"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:Naseleni_mesta",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Населени места',
  serverName: 'Naseleni_mesta',
  visible: false
});

layers["Natura_habitati"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:Natura_habitati",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'BG0000613 - Река Искър',
  serverName: 'Natura_habitati',
  visible: false
});
layers["BG0000627"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:BG0000627",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'BG0000627 - Конунски дол',
  serverName: 'BG0000627',
  visible: false
});
var layerGroupNatura = new LayerGroup({
  layers: [layers["BG0000627"],layers["Natura_habitati"]],
  name: 'Защитени зони и територии'
});

layers["Zeml_granitsi"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:Zeml_granitsi",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Землищни граници',
  serverName: 'Zeml_granitsi',
  visible: false
});
layers["Obshtinska_granica"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:Obshtinska_granica",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Общинска граница',
  serverName: 'Obshtinska_granica',
  visible: false
});
var layerGroupGranici = new LayerGroup({
  layers: [layers["Obshtinska_granica"],layers["Zeml_granitsi"]],
  name: 'Граници'
});

layers["Svlachishta"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:Svlachishta",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Условна граница на терен с наличие на активни свлачищни действия',
  serverName: 'Svlachishta',
  visible: false
});
layers["Transport"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:Transport",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Транспорт',
  serverName: 'Transport',
  visible: false
});

layers["Sgradi_tr"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:Sgradi_tr",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Сгради',
  serverName: 'Sgradi_tr',
  visible: false
});
layers["Kadastar_ot_platnata"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:Kadastar_ot_platnata",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Имоти',
  serverName: 'Kadastar_ot_platnata',
  visible: false
});
layers["KVS_joined"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:KVS_joined",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'КВС',
  serverName: 'KVS_joined',
  visible: false
});
var layerGroupCad = new LayerGroup({
  layers: [layers["KVS_joined"],layers["Kadastar_ot_platnata"],layers["Sgradi_tr"]],
  name: 'Кадастър'
});

layers["Ustroistveni_zoni"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:Ustroistveni_zoni",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Устройствени зони',
  serverName: 'Ustroistveni_zoni',
  visible: false
});
layers["Ustroistveni_zoni_syshtestvuvashti"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:Ustroistveni_zoni_syshtestvuvashti",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Съществуващи устройствени зони',
  serverName: 'Ustroistveni_zoni_syshtestvuvashti',
  visible: false
});
layers["KVS_diss_NTP_Balans"] = new TileLayer({
  source: new TileWMS({
    url: "https://onthemap.org/geoserver/wms",
    crossOrigin: "anonymous",
    params: {
      LAYERS: "Kneja:KVS_diss_NTP_Balans",
      TILED: true
    },
    projection: "EPSG:32635"
  }),
  name: 'Територии с общо предназначение',
  serverName: 'KVS_diss_NTP_Balans',
  visible: false
});
var layerGroupNTP = new LayerGroup({
  layers: [layers["KVS_diss_NTP_Balans"],layers["Ustroistveni_zoni_syshtestvuvashti"],layers["Ustroistveni_zoni"]],
  name: 'Начин на трайно ползване'
});

// let mousePositionControl = MousePosition({
//   className: 'custom-mouse-position',
//   //target: document.getElementById('location'),
//   coordinateFormat: createStringXY(3),
//   undefinedHTML: '&nbsp;'
// });
const mousePositionControl = new MousePosition({
  coordinateFormat: createStringXY(2),
  className: 'custom-mouse-position',
  target: document.getElementById('location'),
});

var zoomToOriginalExtent = new ZoomToExtent({
  label: 'О', tipLabel:'Начална позиция на картата', extent: bounds
});

//vector layer for displaying WFS responses from identification and search
let vectorSource = new Vector();
let vectorLayer = new VectorLayer({
  source: vectorSource,
  name: 'theVectorLayer',
  style: new Style({
    stroke: new Stroke({
      color:'rgba(82, 82, 122,3)',
      width: 2
    }),
    fill: new Fill({
      color: 'rgba(133, 133, 173,0.3)',
    })
  })
});
//vector layer for displaying the selected object from right menu
let vectorSourceSelected = new Vector();
let vectorLayerSelected = new VectorLayer({
  source: vectorSourceSelected,
  name: 'theVectorLayerSelected',
  style: new Style({
    stroke: new Stroke({
      color:'rgba(51, 51, 77,2.5)',
      width: 2
    }),
    fill: new Fill({
      color: 'rgba(82, 82, 122,0.8)',
    })
  })
});

const map = new Map({
  controls: defaults({attribution: true}).extend([mousePositionControl, zoomToOriginalExtent]),
//  controls: defaults({attribution: true}).extend([mousePositionControl]),
  layers: [
    layers["osm"], 
    layers["osmsat"], 
    layerGroupNTP,
    layerGroupCad,
    layers["Transport"],
    layers["Svlachishta"],
    layerGroupGranici,
    layerGroupNatura,
    layers["Naseleni_mesta"],
    layers["AKB_Kneja"],
    layers["KIN"],
    layerGroupRegulacia,
    vectorLayer,
    vectorLayerSelected
  ],
  target: "map",
  view: new View({
    projection: "EPSG:32635",
    center: [266960.28,4818977.33],
    zoom: 11
  })
});
map.getLayerGroup().set('name', 'Слоеве');

// map.getView().on('change:resolution', function(evt) {
//   let resolution = evt.target.get('resolution');
//   let units = map.getView().getProjection().getUnits();
//   let dpi = 25.4 / 0.28;
//   let mpu = olProj.METERS_PER_UNIT[units];
//   let scale = resolution * mpu * 39.37 * dpi;
//   scale = Math.round(scale);
//   document.getElementById('scale').innerHTML = "1 : " + scale;
// });
// map.getView().fit(bounds, map.getSize());

//Table of Contents
/**
* Build a tree layer from the map layers with visible and opacity 
* options.
* 
* @param {type} layer
* @returns {String}
*/
function buildLayerTree(layer) {

  let elem;
  let name = layer.get('name') ? layer.get('name') : "Group";
  let visibility = layer.get('visible');
  let div = "";
  
  //a condition to hide the vector layer from the TOC
  if (name == 'theVectorLayer' || name == 'theVectorLayerSelected' ){
      elem = '';
      return elem;
  }

  //get TOC elements
  if (!layer.getLayers) {
      if (visibility !== true ){
          div = "<li data-layerid='" + name + "'>" +
              "<span>" + layer.get('name')  +
              "<i class='bi bi-toggle-off'></i> " + "</span>";
      }
      else {
          div = "<li data-layerid='" + name + "'>" +
              "<span>" + layer.get('name') + 
              "<i class='bi bi-toggle-on'></i> " + "</span>";
      }
  }
  else{
      div = "<li data-layerid='" + name + "'>" +
              "<span>" + layer.get('name') + 
              "<i class='glyphicon glyphicon-minus'></i> " + "</span>";
  }
  
  if (layer.getLayers) {
      let sublayersElem = ''; 
      let layers = layer.getLayers().getArray(),
              len = layers.length;

      for (let i = len - 1; i >= 0; i--) {
          sublayersElem += buildLayerTree(layers[i]);

      }
      elem = div + " <ul>" + sublayersElem + "</ul></li>";
  } else {
      elem = div + " </li>";
  }
  return elem;
}

/**
* Initialize the tree from the map layers
* @returns {undefined}
*/
function initializeTree() {
  
  let elem = buildLayerTree(map.getLayerGroup());
  $('#layertree').empty().append(elem);

  $('.tree li:has(ul)').addClass('parent_li').find(' > span').attr('title', 'Покажи подслоевете');
  $('.tree li.parent_li > span').on('click', function(e) {
      let children = $(this).parent('li.parent_li').find(' > ul > li');
      if (children.is(":visible")) {
          children.hide('fast');
          $(this).attr('title', 'Отвори').find(' > i').fadeIn(400).addClass('glyphicon-plus').removeClass('glyphicon-minus');
      } else {
          children.show('fast');
          $(this).attr('title', 'Затвори').find(' > i').fadeIn(400).addClass('glyphicon-minus').removeClass('glyphicon-plus');
      }
      e.stopPropagation();
  });
}

/**
* Finds recursively the layer with the specified key and value.
* @param {ol.layer.Base} layer
* @param {String} key
* @param {any} value
* @returns {ol.layer.Base}
*/
function findBy(layer, key, value) {

  if (layer.get(key) === value) {
      return layer;
  }

  // Find recursively if it is a group
  if (layer.getLayers) {
      let layers = layer.getLayers().getArray(),
              len = layers.length, result;
      for (let i = 0; i < len; i++) {
          result = findBy(layers[i], key, value);
          if (result) {
              return result;
          }
      }
  }

  return null;
}

//Legend 
/**
* Build a <img> list from the map layers
* 
* @param {type} layer
* @returns {String}
*/
function buildLegend(layer) {

  let elem;
  //let name = layer.get('name') ? layer.get('name') : "Group";
  //let visibility = layer.get('visible');
  let layerSource = layer.get('serverName');
  let div = "";

  let legendService = "https://onthemap.org/geoserver/Kneja/wms?Service=WMS&REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=15&HEIGHT=20&LAYER="
  
  if (!layer.getLayers && layerSource != null) {
      
      let layerName = layer.get('name');
      let legendSource = legendService + layerSource;
      let layerVisible = layer.get('visible');
      
      if(layerVisible == false){
          div = "<div class='legendItem' legend-layerid='"+ layerName +"'>" +
                  "<span class='legendItemName'>" + layerName + "</span>" +
                  "<img class='' id='legendItem" + layerSource + "' src= '" + legendSource + "'>" +
                "</div>";
       }
       else{
          div = "<div class='legendItem active' legend-layerid='"+ layerName +"'>" +
              "<span class='legendItemName'>" + layerName + "</span>" +
              "<img class='' id='legendItem" + layerSource + "' src= '" + legendSource + "'>" +
              "</div>";
       }
      
                
      //if(layerVisible == false){$("[legend-layerid='"+ layerName +"']").hide();}
  }
  else{
      div = "";
  }

  if (layer.getLayers) {
      let sublayersElem = ''; 
      let layers = layer.getLayers().getArray(),
              len = layers.length;
      for (let i = len - 1; i >= 0; i--) {
          sublayersElem += buildLegend(layers[i]);
          
      }
      elem = div + sublayersElem;
  } else {
      elem = div;
  }
  return elem;

  
}

/**
* Initialize the legend from the map layers
* @returns {undefined}
*/
function initializeLegend() {
  let legendElem = buildLegend(map.getLayerGroup());
  $('#legendMain').append(legendElem);
}

// function switchOsmLayer(layername){
//   var layer = findBy(map.getLayerGroup(), 'name', layername);
// }

/**
 * Search tool - using WFS GetFeature from searchInput box to retrieve 
 * info from layer
 * 
 */
 function searchForFeatures(inputVal) {

  console.log(inputVal);
  if (inputVal !== ''){

      vectorSource.clear();
      vectorSourceSelected.clear();

      let searchValue = '%' + inputVal + '%';
      
      // generate a GetFeature request
      let featureRequest = new WFS().writeGetFeature({
        srsName: 'EPSG:32635',
        featureNS: 'Kneja',
        featurePrefix: 'Kneja',
        featureTypes: ['KVS_joined', 'Kadastar_ot_platnata'],
        outputFormat: 'application/json',
        filter: like('UPI_Ident', searchValue, '%')
      })
  
      fetchFeatures(featureRequest);

  }
}

map.on('click', function(evt) {

  vectorSource.clear();
  vectorSourceSelected.clear();

  let coords = evt.coordinate;
  let bbox_area = [coords[0] - 1,coords[1] - 1,coords[0] + 1,coords[1] + 1];
  let coordX = coords[0].toString().replace(/^(\d+\.\d{2}).*$/, '$1');
  let coordY = coords[1].toString().replace(/^(\d+\.\d{2}).*$/, '$1');

  let coordsForInput = coordX + ', ' + coordY;
  //document.getElementById('searchInput').value = coordsForInput;
  //a letiable to hold the features returned from the POST
  let features;

  // generate a GetFeature request
  let featureRequest = new WFS().writeGetFeature({
      srsName: 'EPSG:32635',
      featureNS: 'Kneja',
      featurePrefix: 'Kneja',
      featureTypes: ['KVS_joined', 'Kadastar_ot_platnata'],
      outputFormat: 'application/json',
      filter: new Bbox('the_geom', bbox_area)
  });
 
  fetchFeatures(featureRequest);

});

/**
 * Sends a XMLHttpRequest to the Geoserver and waits for 
 * success or error response
 * 
 * @param {type} featureRequest
 * 
 */
 function fetchFeatures(featureRequest){

  $('#resultsPanel').empty();
  $('div#resultsPanel').css('height', '');

  let body = new XMLSerializer().serializeToString(featureRequest);

  let httpRequest = new XMLHttpRequest();
  let requestUrl = "https://onthemap.org/geoserver/wfs";
  httpRequest.open("POST", requestUrl, true);
  httpRequest.setRequestHeader("Content-type", "text/plain;charset=UTF-8");

  httpRequest.onreadystatechange = function() {//Call a function when the state changes.
    if(httpRequest.readyState == 4 && httpRequest.status == 200) {
      try{
          $('#alertWrapper').hide();
          vectorSourceSelected.clear();

          let features = new GeoJSON().readFeatures(httpRequest.responseText);
          vectorSource.addFeatures(features);
          zoomToExtent(vectorSource.getExtent());
          fillFeaturesInList(features);           
      }
      catch(e){

        $('.isLoadingIcon').hide();
        if (e.code == 25){
            $('#alertWrapper .alertMessage').text('Не са намерени резултати от търсенето!')
            $('#alertWrapper').show();
        } else {
            //$('#alertWrapper .alertMessage').text('Възникна проблем, моля опитайте отново!')
            //$('#alertWrapper').show();
            console.log(e);
        }
        
      }
    }
  }
  httpRequest.send(body);

}

/**
* Error handler for fetch request
* 
* @param {type} error
* 
*/
function handleFetchErrors(error){

  $('.isLoadingIcon').hide();

  if (error.code = 25){
      $('#alertWrapper .alertMessage').text('no result')
      $('#alertWrapper').show();
  }
  else {
      $('#alertWrapper .alertMessage').text('some other error')
      $('#alertWrapper').show();
  }
}

/**
* Loads the returned features from search/identification to a list of found features
* 
* @param {type} features
* 
*/

function focusSelectedResult(searchId, featureId){
  $('.searchResult .searchResultCollapse').removeClass('show');
  $('.searchResult #collapse'+ searchId).addClass('show');
  
  vectorSourceSelected.clear();
  vectorSourceSelected.addFeature(vectorSource.getFeatureById(featureId));  
  zoomToExtent(vectorSource.getFeatureById(featureId).getGeometry().getExtent());
}
window.focusSelectedResult = focusSelectedResult;

function fillFeaturesInList(features){

  //let featuresArray = features.getArray();
  let len = features.length;
  for (let i = len - 1; i >= 0; i--){
      
    let feature = features[i];

    let featureProperties = feature.getProperties();
    let featureId = feature.getId();
    let div = '';
    
    div = '<div class="card searchResult">' + 
            '<div class="card-header searchResultHeading" id="heading'+ i +'" onClick="focusSelectedResult(\''+ i +'\', \''+ featureId +'\')">' + 
              '<h5 class="mb-0 searchResultTitle">';
    
    if (/^Kadastar_ot_platnata/.test(featureId)){
      div +=    '<i class="bi bi-geo-alt">Имоти: ' + featureProperties.UPI +'</i>';
    } else if (/^KVS_joined/.test(featureId)){
      div +=    '<i class="bi bi-geo-alt">КВС: ' + featureProperties.upi +'</i>';
    // } else if (/^PUP_Imoti_poly/.test(featureId)){
    //   div +=    '<i class="bi bi-geo-alt">ПУП: ' + featureProperties.Nomer_UPI +'</i>';
    }

    div +=  '</h5>' +
          '</div>' +

          '<div id="collapse'+ i +'" class="collapse searchResultCollapse" aria-labelledby="heading'+ i +'" data-parent="#resultsPanel">' +
            '<div class="card-body searchResultBody">' +
              '<ul>';
    if (/^Kadastar_ot_platnata/.test(featureId)){
      let pupPlosht = featureProperties.Shape_Area.toString();
      pupPlosht = pupPlosht.substring(0, pupPlosht.indexOf('.')+3);

    //   div +=    featureProperties.Zemlishte ? '<li><span class="key">Землище: </span><span class="value">'+ featureProperties.Zemlishte +'</span></li>':'';
    //   div +=    '<li><span class="key">Площ: </span><span class="value">'+ pupPlosht + ' кв.м</span></li>';
    // } else if (/^Cadastre/.test(featureId)){

    //   let pupPlosht = featureProperties.Shape_Area.toString();
    //   pupPlosht = pupPlosht.substring(0, pupPlosht.indexOf('.')+3);

    //   div +=    featureProperties.MESTNOST_T ? '<li><span class="key">Местност: </span><span class="value">'+ featureProperties.MESTNOST_T +'</span></li>':'';
    //   div +=    featureProperties.VIDT_N14 ? '<li><span class="key">Вид територия: </span><span class="value">'+ featureProperties.VIDT_N14 +'</span></li>':'';
    div +=    featureProperties.NTP_new ? '<li><span class="key">НТП: </span><span class="value">'+ featureProperties.NTP_new +'</span></li>':'';
    //   div +=    featureProperties.Address ? '<li><span class="key">Адрес: </span><span class="value">'+ featureProperties.Address +'</span></li>':'';
      div +=    '<li><span class="key">Площ: </span><span class="value">'+ pupPlosht +' кв.м</span></li>';

    } else if (/^KVS_joined/.test(featureId)){

      let pupPlosht = featureProperties.Shape_Area.toString();
      pupPlosht = pupPlosht.substring(0, pupPlosht.indexOf('.')+3);

    //   div +=    featureProperties.Etajnost_o ? '<li><span class="key">Етажност: </span><span class="value">'+ featureProperties.Etajnost_o +'</span></li>':'';
    //   div +=    featureProperties.Platnost ? '<li><span class="key">Плътност: </span><span class="value">'+ featureProperties.Platnost +'</span></li>':'';
    //   div +=    featureProperties.Kint ? '<li><span class="key">Кинт: </span><span class="value">'+ featureProperties.Kint +'</span></li>':'';
    //   div +=    featureProperties.Ozelenqvan ? '<li><span class="key">Озеленяване: </span><span class="value">'+ featureProperties.Ozelenqvan +'</span></li>':'';
      div +=    featureProperties.sobstvenost ? '<li><span class="key">Вид собственост: </span><span class="value">'+ featureProperties.sobstvenost +'</span></li>':'';
      div +=    featureProperties.USETYPE_OLD ? '<li><span class="key">НТП: </span><span class="value">'+ featureProperties.USETYPE_OLD +'</span></li>':'';
    //   div +=    featureProperties.Zapoved ? '<li><span class="key">Заповед: </span><span class="value">'+ featureProperties.Zapoved +'</span></li>':'';
    //   div +=    featureProperties.Nomer_Imot ? '<li><span class="key">Номер имот: </span><span class="value">'+ featureProperties.Nomer_Imot +'</span></li>':'';
    //   div +=    featureProperties.ustanoveno ? '<li><span class="key">Устройствено отреждане: </span><span class="value">'+ featureProperties.ustanoveno +'</span></li>':'';
    //   div +=    featureProperties.Address ? '<li><span class="key">Адрес: </span><span class="value">'+ featureProperties.Address +'</span></li>':'';
      div +=    '<li><span class="key">Площ: </span><span class="value">'+ pupPlosht +' кв.м</span></li>';

    }              
    div +=    '</ul>' +
            '</div>' +
          '</div>' +
          '</div>';

    $('#resultsPanel').append(div);

  }

  $('.isLoadingIcon').hide();
  $('.clearIcon').show();

  let resultsPanelH = $('#resultsPanel').height();
  let windowH = $(window).height() - 100;
  if (resultsPanelH > windowH){
      //$('#resultsPanel').height($(window).height()-110);  
      $('div#resultsPanel').css('height', $(window).height()-110);
  } else {
      $('div#resultsPanel').css('height', '');
  }
  
  //$('.scrollerContainer').jScrollPane();

}

/**
* Clears vector layer and results
* 
*/
function clearRightPanel(){
  vectorSource.clear();
  vectorSourceSelected.clear();
  
  $('.clearIcon').hide();
  $('#resultsPanel').empty();
  $('#searchInput').val('');
  $('div#resultsPanel').css('height', '');
}
window.clearRightPanel = clearRightPanel;
/**
 * Zooms the map to the given extent 
 * 
 * @param {type} extent
 * 
 */
function zoomToExtent(featureExtent){
  map.getView().fit([featureExtent[0]-5,featureExtent[1]-5,featureExtent[2]+5,featureExtent[3]+5], {size: map.getSize(), maxZoom:18, duration: 1000 });
  //map.getView().animate({zoom: 15},{ center: getCenter([featureExtent[0]-5,featureExtent[1]-5,featureExtent[2]+5,featureExtent[3]+5]) }, { duration: 750 });
}

$(function() {
  
  initializeTree();
  initializeLegend();

  $("#searchInput").on("keyup",function(){
    $('.isLoadingIcon').show();
    delay(function(){
      searchForFeatures($('#searchInput').val());
    }, 500);
  });


  // Handle osm visibility control
  $('.btn-osm').on('click', function() {
    var layername = $(this).attr('id');
    var layerOsm = findBy(map.getLayerGroup(), 'name', 'osm');
    var layerOsmsat = findBy(map.getLayerGroup(), 'name', 'osmsat');

    if (layername == 'osm'){
      layerOsm.setVisible(true);
      layerOsmsat.setVisible(false);
      $('#osmsat').removeClass('hidden');
      $('#osm').addClass('hidden');
    } else if (layername == 'osmsat'){
      layerOsm.setVisible(false);
      layerOsmsat.setVisible(true);
      $('#osmsat').addClass('hidden');
      $('#osm').removeClass('hidden');
    }
  });

  // Handle visibility control
  $('i').on('click', function() {
    var layername = $(this).closest('li').data('layerid');
    var layer = findBy(map.getLayerGroup(), 'name', layername);
    
    if (!layer.getLayers) {
      layer.setVisible(!layer.getVisible());

      if (layer.getVisible()) {
          $(this).removeClass('bi-toggle-off').addClass('bi-toggle-on');
          //shows legend of selected item
          //$("[legend-layerid='"+ layername +"']").show();
          $("[legend-layerid='"+ layername +"']").addClass("active");

      } else {
          $(this).removeClass('bi-toggle-on').addClass('bi-toggle-off');
          //shows legend of selected item
          //$("[legend-layerid='"+ layername +"']").hide();
          $("[legend-layerid='"+ layername +"']").removeClass("active");
      }
    }
  });
});